import React, { useMemo } from "react";

import { Table } from "antd";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const RelationshipTable = ({ relationships, removeRelation, className }) => {
  const columns = [
    {
      title: "Entity",
      dataIndex: "name",
      key: "name",
    },
    {
      dataIndex: "Action",
      title: "",
      // className: classes.TextLeft,
      width: 125,
      render: (value, record, index) => {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton
              onClick={(e) => removeRelation(record.name)}
              style={{
                marginLeft: "5px",
                color: "#C72C2C",
              }}
            >
              <DeleteOutlineOutlinedIcon fontSize="inherit" />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const dataSource = useMemo(() => {
    const sortedRelationships = [...relationships];
    sortedRelationships.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    return sortedRelationships.map((entity) => ({ name: entity, key: entity }));
  }, [relationships]);

  return (
    <Box sx={{ width: "50%" }} className={className}>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        size="small"
        style={{
          paddingBottom: "20px",
        }}
      />
    </Box>
  );
};

export default React.memo(RelationshipTable);
